import { Formik } from 'formik';
import { type TradeInDataFragment } from '../../../api/fragments';
import { StyledForm } from '../../shared/ApplicationDetailsPage/standard/ApplicationForm';
import TradeInAction from './TradeInAction';

export type TradeInApplicationFormValues = TradeInDataFragment;

type TradeInFormProps = {
    tradeIn: TradeInDataFragment;
};

const TradeInForm = ({ tradeIn }: TradeInFormProps) => {
    if (!tradeIn || tradeIn.__typename !== 'AudiTradeIn') {
        throw new Error('TradeInKind is not AudiTradeIn');
    }

    return (
        <Formik<TradeInApplicationFormValues> initialValues={tradeIn} onSubmit={undefined}>
            {({ handleSubmit }) => (
                <StyledForm id="tradeInApplicationForm" name="tradeInApplicationForm" onSubmitCapture={handleSubmit}>
                    <TradeInAction tradeIn={tradeIn} />
                </StyledForm>
            )}
        </Formik>
    );
};

export default TradeInForm;
